import {
    ComponentElements,
    ComponentInjector,
    ComponentObject,
    ComponentService,
    ComponentSelectors,
    Validator,
    Injectable
} from '@atypon/ui-utils';

class Texts extends ComponentObject {
    input = "INPUT";
    select = "SELECT";
    checkbox = "checkbox";
    email = "email"
}

class ClassList extends ComponentObject {
    error = "error";
    jsError = "js-error";
    small = "small";
    inputError = "input--error";
}

class Selectors extends ComponentSelectors {
    previousErrors = '.error:not(.js-error)';
    jsRequired = '.js-required';
}

class Elements extends ComponentElements<Selectors> { }

interface FormValidation extends ComponentService<Selectors, Elements, ClassList, Texts> { }

@Injectable()
@ComponentInjector(Selectors, Elements, ClassList, Texts)
class FormValidation {

    /**
     * check if it matches email schema
     */
    isEmail(email: string | HTMLInputElement) {
        return Validator.prototype.isEmail(email)
    }

    /**
     * check if some option was selected
     */
    isSelected(selectElement: HTMLSelectElement) {
        return selectElement.selectedIndex > 0;
    };

    /**
     * check if checkbox was checked
     */
    isChecked(checkbox: HTMLInputElement) {
        return checkbox.checked;
    };

    /**
     * helper , used within this class only
     */
    validationHandler(condition, element) {
        const showValidationError = element => {
            const isMsgExist = document.getElementById(`${element.getAttribute('name')}-invalid`);
            let errElement = document.createElement('div');
            errElement.textContent = element.getAttribute('data-error-msg');
            errElement.classList.add(this.classList.error, this.classList.small, this.classList.jsError);
            errElement.setAttribute('id', `${element.getAttribute('name')}-invalid`);
            element.parentNode.querySelector(this.selectors.previousErrors)?.remove();
            isMsgExist || element.parentNode.appendChild(errElement);
            element.setAttribute('prev-describedby', element.getAttribute('aria-describedby'));
            element?.setAttribute('aria-describedby', errElement.getAttribute('id'));
            element?.classList.add(this.classList.inputError);
            element.focus();
        };

        const clearError = element => {
            document.getElementById(`${element.getAttribute('name')}-invalid`)?.remove();
            element?.getAttribute('prev-describedby') &&
                element?.setAttribute('aria-describedby', element?.getAttribute('prev-describedby'));
            element?.classList.remove(this.classList.inputError);
        };

        if (!condition) {
            showValidationError(element);
            return true;
        }
        clearError(element);
        return false;
    };



    /**
     *  need to add '.js-required' to the required field + data-error-msg
     *  returns true if there is an invalid field
     */

    validate(e) {
        const form = e.target;
        let invalidFields = [];

        form.querySelectorAll(this.selectors.jsRequired).forEach(requiredElement => {
            const elementType = requiredElement.tagName;
            let condition = false;

            switch (elementType) {
                case this.texts.input:
                    if (requiredElement.getAttribute('type') === this.texts.email) {
                        if (this.isEmail(requiredElement)) {
                            condition = true;
                        }
                    } else if (requiredElement.getAttribute('type') === this.texts.checkbox) {
                        if (this.isChecked(requiredElement)) {
                            condition = true;
                        }
                    }
                    break;

                case this, this.texts.select:
                    if (this.isSelected(requiredElement)) {
                        condition = true;
                    }
                    break;

                default:
                    break;
            }

            invalidFields.push(this.validationHandler(condition, requiredElement));
        });

        return invalidFields.includes(true);
    };

}

export default FormValidation